import React, {useEffect, useState} from 'react';
import { KoFormBuilder, KoForm, Upload, KoText, KoToast, KoLoader, KoImage, KoSelect, KoActivityTypes, KoTextArea, KoNumber } from 'packages';
import styles from './curd.module.scss';
import { getCookie } from 'shared/utils/cookies';
import ImgCrop from 'antd-img-crop';
import { ATYPE, CUSTOMER_MANAGEMNT_WORKFLOW } from '../../constant';

function BusinessInfoCrud({ form, handleFinish, settings, onValuesChange }) {

  const [loading, setLoading] = useState(false);
  const [customerStates ] = useState(CUSTOMER_MANAGEMNT_WORKFLOW);
  const [activityTypes] = useState(ATYPE);
  useEffect(()=>{
    form?.resetFields();
  },[]);


  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      KoToast.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      KoToast.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
  };


  const CustomerStatus = ({ value, onChange }) => (
    <KoSelect
      value={customerStates?.length > 0 ? value :''}
      showSearch
      defaultValue={customerStates?.length > 0 ? customerStates[0].value : ''}
      onChange={v => onChange(v)}
      placeholder='Select status'
      options={customerStates}
      optionFilterProp="label"
      optionRender={(option) => {
        const label = option?.data?.label;
        const formattedLabel = typeof label === 'string' ? label.replace(" ", '') : '';
        return (
          <div className={styles.statusWrapper} >
            <div style={{borderColor: option?.data?.color}} className={`${styles.status} ${styles[formattedLabel]}`} role="img" aria-label={label} />
            <KoText text={label} />
          </div>
        );
      }}
    />
  );


  const CustomerType = ({ value, onChange }) => (
    <KoActivityTypes value={ value}
      defaultValue={activityTypes?.length > 0 ? activityTypes[0].value : ''}
      options={activityTypes}
      onChange={v => onChange(v)} />
     
  );

  const TextArea = ({ value, onChange }) => (
    <KoTextArea value={value} onChange={onChange} showCount
      maxLength={100}/>
  );
  
  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues: settings,
    colon: true,
    fields: [
      {
        key: 'companyName', label: 'Company Name' , placeholder: 'Ex: qubernet, inc.', colSpan: 2,
        rules: [
          {
            required: true,
            message: 'Company name is required'
          }
        ]
      },
      {
        key: 'type', label: 'Customer Type', placeholder: 'Enter GST', colSpan: 1 ,  widget: CustomerType
      },
      {
        key: 'status', label: 'Customer Status', placeholder: 'Enter GST', colSpan: 1,  widget: CustomerStatus
      },
      {
        key: 'url', label: 'Website Url', placeholder: 'Ex: https://qubernet.com', colSpan: 2
      },
      {
        key: 'GST', label: 'GST Number', placeholder: 'Enter GST', colSpan: 1
      },
      {
        key: 'PAN', label: 'PAN/EIN Number', placeholder: 'Enter PAN/EIN', colSpan: 1
      },
      {
        key: 'TAN', label: 'TAN Number', placeholder: 'Enter TAN', colSpan: 1
      },
      {
        key: 'UAN', label: 'UAN Number', placeholder: 'Enter UAN', colSpan: 1
      },
      {
        key: 'subscriptionAmount', label: 'Plans / Pricing / Subscription / Budget ', placeholder: 'Ex: 10000', colSpan: 1, widget: KoNumber
      },
      {
        key: 'link', label: 'Notes', placeholder: 'Enter Notes', colSpan: 4, widget: TextArea
      }
    ]
  };


  const props = {
    name: 'files',
    action: `${process.env.REACT_APP_PROXY_HOST}/api/v1/org/upload`,
    data:{service:'admin', module:'customers'},
    headers: {
      Authorization: `Bearer ${getCookie("accessToken")}`
    },
    onChange(info) {
      setLoading(true);
      if (info.file.status !== 'uploading') {
        onValuesChange({
          logo: info.fileList
        }, 'refresh');
      }
      if (info.file.status === 'done') {
        KoToast.success(`${info.file.name} file uploaded successfully`);
        setLoading(false);
      } else if (info.file.status === 'error') {
        setLoading(false);
        KoToast.error(`${info.file.name} file upload failed.`);
      }
    }
  };

  const uploadButton = (
    <div className={styles.dndArea}>
      {loading && <KoLoader size='small'/>}
      {settings?.logo?.length > 0   ?
        <KoImage preview={false} src={settings?.logo[0].url}/>:
        <>
          {/* <KoIcon name='ImagesOutlined'/> */}
          <KoText className={styles.fileInfo} text='At least 256 x 256px PNG or JPG file'/>
        </>}
    </div>
  );


  return (
    <div className={styles.wrapper}>
      {settings.customerId && <KoForm.Item
        name={["logo"]}
        valuePropName={["logo"]}
        getValueFromEvent={normFile}

      >
        <ImgCrop>
          <Upload {...props}
            className={styles.upload}
            beforeUpload={beforeUpload}
            max={{ count: 1 }}
            showUploadList={false}
            showPreviewIcon={false}
            listType="picture-card"
          >
            {uploadButton}
          </Upload>
        </ImgCrop>
      </KoForm.Item>}
      <KoFormBuilder form={form} meta={meta} />
    </div>
  );
};

export default BusinessInfoCrud;